export default __webpack_public_path__ + "static/media/desensibilisierung_01.4168c737.png";